import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from '@/core/ui';
import { getStickerStateName } from '@/warehouse/helpers';
import { getStickerStateChipColor } from './helpers';
const StickerStateChip = ({ state, ...props }) => {
    return (_jsx(Chip, { variant: "filled", shape: "rect", size: "small", color: getStickerStateChipColor(state), label: getStickerStateName(state), ...props }));
};
export { StickerStateChip };
